import React from 'react';

class SMOAnalyticsCollectionItem extends React.Component {
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      title: nextProps.title,
      prefix: nextProps.prefix,
      amount: nextProps.amount,
      unit: nextProps.unit,
    });
  }
  
  render() {
    return (
      <div className="summary-total__box">
        <h4 className="dashboard-title2 mb25">{this.props.title}</h4>
        <p className="ta-c">
          <span className="summary-total__unit">{this.props.prefix}</span>
          <span className="summary-total__number ml5 mr5">{this.props.amount}</span>
          <span className="summary-total__unit">{this.props.unit}</span>
        </p>
      </div>
    );
  }
}

export default SMOAnalyticsCollectionItem;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/analytics/SMOAnalyticsCollectionItem.jsx